import React ,{useState}from 'react';
import { Row, Col,Typography } from 'antd';
import {  useNavigate } from 'react-router-dom';
import Background from '../../../../static/img/icon-app-backgroud.png';
import BackgroundIhealth from '../../../../static/img/icon-app-background-ihealth.png';
import QRCode from 'qrcode.react';
const PCPage = (props) => {
    const { Paragraph } = Typography;
    const navigate = useNavigate();

    const [pcTip1, setPcTip1] = useState('');
    const [pcTip2, setPcTip2] = useState('');
    React.useEffect(() => {
        var lang = (navigator.systemLanguage ? navigator.systemLanguage : navigator.language);
        if (lang.substring(0, 2) === 'zh') {
            setPcTip1('扫描二维码下载')
            setPcTip2('更新日志')
        }else{
            setPcTip1('Scan the QR code to download')
            setPcTip2('What\'s New')

        }

    }, [])
    function onClick() {
        navigate('../')
    }
    return (
        <div style={{ display: props.isPhone ? "none" : "", height: '100%', width: '100%', }}>
        <Row style={{ height: '60px' }}>
            <img src={require('../../../../static/img/ic-home-logo.png')} alt="logo"
                style={{ marginTop: '15px', marginLeft: '63px' }} height="34px"
                onClick={onClick} />
        </Row>
        <div style={{ backgroundColor: '#FF5300', width: '100vw', height: '1px' }}></div>
        <div style={{ width: '100vw', display: 'flex', justifyContent: 'center', }}>
            <div style={{
                marginTop: '150px', height: '300px', width: '300px',
                backgroundImage: `url(${Background})`, backgroundSize: 'cover'
            }}>
                <div style={{ marginTop: '10px', marginLeft: '10px', height: '105px', width: '105px',  backgroundSize: 'cover', borderRadius: '10px' }}>
                <img src={props.appIcon} alt="logo"
                height="105px" style={{borderRadius: '10px' }}
                 />
                </div>
                <div style={{ marginTop: '70px', marginLeft: '185px', height: '105px', width: '105px', borderRadius: '10px' }}>
                    <QRCode
                        id="qrCode"
                        value={props.shortLink}
                        size={105} // 二维码的大小
                        fgColor="#000000" // 二维码的颜色
                        bgColor='#EFF2F2'
                        imageSettings={{ // 二维码中间的logo图片
                            height: 105,
                            width: 105,
                            excavate: true, // 中间图片所在的位置是否镂空
                        }}
                    />
                </div>

            </div>
        </div>

        <div style={{ marginLeft: '25vw', width: '50vw', }}>
            <Row style={{ marginTop: '20px' }}>
                <Col>
                    <img src={props.appPlatformIcon} style={{ width: '24px', height: '24px', marginTop: '18px' }}></img>
                </Col>
                <Col style={{ fontSize: '35px', color: '#3D3D3D' }}>
                    {props.appName}
                </Col>
            </Row>
            <div style={{ fontSize: '20px', color: '#3D3D3D' }}>
                {pcTip1}
            </div>
            <Paragraph style={{ fontSize: '20px', color: '#3D3D3D' }}>
                {props.shortLinkTip}
            </Paragraph>
        </div>

        <div style={{ marginTop: '20px', marginLeft: '25vw', backgroundColor: '#D8D8D8', width: '50vw', height: '1px' }}></div>
        <div style={{ width: '100vw', display: 'flex', justifyContent: 'center', }}>
            <div>
                <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', fontSize: '20px', color: '#3D3D3D' }}>{props.appVersion}</div>
                <div style={{ display: 'flex', justifyContent: 'center', fontSize: '20px', color: '#3D3D3D' }}>{props.appUpTime}</div>
            </div>
        </div>
        <div style={{ marginTop: '30px', marginLeft: '25vw', backgroundColor: '#D8D8D8', width: '50vw', height: '1px' }}></div>

        <div style={{  marginTop: '30px',marginLeft: '25vw', fontSize: '18px', color: '#3D3D3D' }}>
           {pcTip2}
        </div>
        <Paragraph style={{ marginLeft: '27vw', fontSize: '18px', color: '#3D3D3D' }}>
            {props.description}
        </Paragraph>
    </div>
    

    )

}

export default PCPage